import React from 'react';

import { TitleLoaded } from './components/TitleLoaded';
import { TitleLoading } from './components/TitleLoading';

import type { TitleProps } from './types';

export const Title = (props: TitleProps) => {
  const {
    isLoaded,
    destinationText,
    price,
    currencyCode,
    type,
    isMobile,
    className,
  } = props;
  if (!isLoaded) {
    return (
      <TitleLoading
        destinationText={destinationText}
        type={type}
        isMobile={isMobile}
        className={className}
      />
    );
  }

  return (
    <TitleLoaded
      destinationText={destinationText}
      type={type}
      price={price}
      currencyCode={currencyCode}
      isMobile={isMobile}
      className={className}
    />
  );
};
